import { flow as _flow } from 'lodash';
import { useMemo } from 'react';
import { Editor, createEditor } from 'slate';
import { withHistory } from 'slate-history';
import { withReact } from 'slate-react';
import { SlatePlugin } from '../types/plugin';

/**
 * A hook that creates a custom editor instance with the specified plugins.
 * @param plugins
 * @returns <Editor>
 */
export const useCustomEditor = <T extends Editor = Editor>(plugins: SlatePlugin<T>[] = []): Editor => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo<Editor>(() => _flow(withHistory, withReact, ...plugins)(createEditor()), []);
};
